module.exports = __webpack_public_path__ + "media/images/img-hobby-2-582c61c1.jpg";